(() => {
  'use strict';
  if (window.__SQ_PRODUCT_PERFORMANCE_FAST_PATH_V3__) return;
  window.__SQ_PRODUCT_PERFORMANCE_FAST_PATH_V3__ = true;
  window.SQProductReadiness = true;

  window.__SQ_CARD_STABLE_V4__ = true;
  window.__SQ_PRODUCT_FORM_CONNECTION_GUARD_V1__ = true;
  window.__SQ_EXPANDED_CLOSE_GUARD_V5__ = true;
  window.__SQ_EXPANDED_CARD_FINAL_POLISH__ = true;
  window.__SQ_UNIVERSAL_FAVORITES_ENGINE_GUARD__ = true;
  window.__SQ_UNIVERSAL_EXPANDED_SINGLE_OWNER_V1__ = true;
  window.__SQ_HOME_FEATURED_HEART_MATCH__ = true;

  const FORM = '.premium-product-form,form[data-premium-product-form]';
  const ADD = '[data-premium-add-text]';
  const BUY = '[data-premium-buy-now]';
  const CART_CLOSE = [
    'cart-drawer-component dialog [data-dialog-close]',
    'cart-drawer-component dialog [ref="closeButton"]',
    'cart-drawer-component dialog .button--close',
    'cart-drawer-component dialog .cart-drawer__close',
    'cart-drawer-component dialog button[aria-label*="close" i]'
  ].join(',');

  const active = new WeakSet();
  const root = () => String(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');

  function stop(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function setBusy(button, state, checkout = false) {
    if (!(button instanceof HTMLButtonElement)) return;
    const label = button.querySelector('[data-premium-add-text-label],span');
    if (state) {
      button.dataset.sqFastLabel = label?.textContent || '';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = checkout ? 'Opening checkout…' : 'Adding…';
    } else {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.classList.remove('loading', 'is-loading');
      if (label && button.dataset.sqFastLabel) label.textContent = button.dataset.sqFastLabel;
      delete button.dataset.sqFastLabel;
    }
  }

  function status(form, text = '', error = false) {
    let node = form.closest('.premium-product-page')?.querySelector('[data-sq-product-fast-status]');
    if (!node) {
      node = document.createElement('p');
      node.className = 'sq-product-status';
      node.dataset.sqProductFastStatus = '';
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      form.querySelector('.premium-action-buttons')?.after(node);
    }
    if (!node) return;
    node.textContent = text;
    node.hidden = !text;
    node.dataset.state = error ? 'error' : text ? 'success' : '';
  }

  function line(form) {
    const id = String(
      form.querySelector('input[name="id"],[data-premium-variant-id]')?.value || ''
    ).trim().split('/').pop();
    const quantity = Math.max(
      1,
      Math.floor(Number(
        form.querySelector('[data-premium-quantity-display],input[name="quantity"],[data-premium-quantity]')?.value || 1
      ))
    );
    return /^\d+$/.test(id) ? { id: Number(id), quantity } : null;
  }

  function addPayload(form) {
    const item = line(form);
    if (!item) return null;

    const properties = {};
    new FormData(form).forEach((value, key) => {
      if (!(value instanceof File) && key.startsWith('properties[') && key.endsWith(']')) {
        properties[key.slice(11, -1)] = String(value);
      }
    });

    const sellingPlan = String(form.querySelector('[name="selling_plan"]')?.value || '').trim();
    const lineItem = { ...item };
    if (Object.keys(properties).length) lineItem.properties = properties;
    if (/^\d+$/.test(sellingPlan)) lineItem.selling_plan = Number(sellingPlan);

    return {
      items: [lineItem],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: location.pathname
    };
  }

  function renderCart(data) {
    const drawer = document.querySelector('cart-drawer-component');
    if (data?.sections && typeof drawer?.renderContents === 'function') {
      try {
        drawer.renderContents(data);
        return;
      } catch (_) {}
    }

    Object.entries(data?.sections || {}).forEach(([id, html]) => {
      const current = document.getElementById(`shopify-section-${id}`);
      if (!current || !html) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.getElementById(`shopify-section-${id}`) || parsed.body.firstElementChild;
      if (fresh) current.innerHTML = fresh.innerHTML;
    });
  }

  function openCart(sections = {}) {
    if (window.__SQ_CART_SINGLE_PATH__?.openPrimary) {
      void window.__SQ_CART_SINGLE_PATH__.openPrimary(null, sections);
      return;
    }

    const drawer = document.querySelector('cart-drawer-component');
    try {
      if (typeof drawer?.open === 'function') drawer.open();
      else {
        const dialog = drawer?.querySelector('dialog');
        if (dialog && !dialog.open) dialog.showModal();
      }
    } catch (_) {}
  }

  function directCheckout(form, button) {
    const item = line(form);
    if (!item) {
      status(form, 'Choose an available product option first.', true);
      return;
    }

    setBusy(button, true, true);
    const fastForm = document.createElement('form');
    fastForm.method = 'post';
    fastForm.action = `${root()}cart/add`;
    fastForm.hidden = true;

    const source = new FormData(form);
    const copied = new Set();
    source.forEach((value, key) => {
      if (value instanceof File || key === 'sections' || key === 'sections_url' || key === 'return_to') return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = String(value);
      fastForm.appendChild(input);
      copied.add(key);
    });

    if (!copied.has('id')) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'id';
      input.value = String(item.id);
      fastForm.appendChild(input);
    }
    if (!copied.has('quantity')) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      input.value = String(item.quantity);
      fastForm.appendChild(input);
    }

    const returnTo = document.createElement('input');
    returnTo.type = 'hidden';
    returnTo.name = 'return_to';
    returnTo.value = `${root()}checkout`;
    fastForm.appendChild(returnTo);

    document.body.appendChild(fastForm);
    HTMLFormElement.prototype.submit.call(fastForm);
  }

  async function add(form, button) {
    if (!(form instanceof HTMLFormElement) || active.has(form)) return;
    const body = addPayload(form);
    if (!body) {
      status(form, 'Choose an available product option first.', true);
      return;
    }

    active.add(form);
    setBusy(button, true, false);
    status(form);
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);

    try {
      const response = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        signal: controller.signal,
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.description || data.message || 'This item could not be added.');

      renderCart(data);
      status(form, 'Added to your shopping bag.');
      openCart(data.sections || {});
    } catch (error) {
      status(
        form,
        error?.name === 'AbortError'
          ? 'The cart request took too long. Please try again.'
          : (error?.message || 'This item could not be added.'),
        true
      );
    } finally {
      clearTimeout(timer);
      active.delete(form);
      setBusy(button, false, false);
      form.closest('.premium-product-page')?.classList.remove('loading', 'is-loading');
    }
  }

  function closeCartNow(button) {
    const component = button.closest('cart-drawer-component');
    const dialog = component?.querySelector('dialog');
    const scrollY = Math.abs(Number.parseFloat(document.body.style.top || '')) || window.scrollY;

    if (history.state?.cartDrawerOpen) history.replaceState(null, '');
    if (dialog instanceof HTMLDialogElement) {
      dialog.classList.remove('dialog-closing');
      dialog.style.animation = 'none';
      dialog.style.setProperty('--dialog-drawer-closing-animation', 'none');
      try { if (dialog.open) dialog.close(); } catch (_) {}
    }

    component?.classList.remove('active', 'is-open', 'sq-cart-opening');
    component?.removeAttribute('open');
    document.documentElement.classList.remove('sq-single-cart-active', 'sq-favorites-cart-active');
    document.documentElement.removeAttribute('scroll-lock');
    Object.assign(document.body.style, { width: '', position: '', top: '' });

    requestAnimationFrame(() => {
      if (dialog instanceof HTMLElement) {
        dialog.style.animation = '';
        dialog.style.removeProperty('--dialog-drawer-closing-animation');
      }
      window.scrollTo({ top: scrollY, behavior: 'instant' });
    });
  }

  window.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const close = target.closest(CART_CLOSE);
    if (close) {
      stop(event);
      closeCartNow(close);
      return;
    }

    const button = target.closest(`${FORM} ${ADD},${FORM} ${BUY}`);
    if (!(button instanceof HTMLButtonElement)) return;
    const form = button.closest(FORM);
    if (!(form instanceof HTMLFormElement)) return;

    stop(event);
    if (button.matches(BUY)) directCheckout(form, button);
    else void add(form, button);
  }, true);

  window.addEventListener('submit', (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form?.matches(FORM)) return;
    stop(event);
    void add(form, form.querySelector(ADD));
  }, true);

  window.addEventListener('pageshow', () => {
    document.querySelectorAll(`${FORM} button[aria-busy="true"]`).forEach((button) => setBusy(button, false));
  });
})();
